import CoursePage from './CoursePage';
import useEvents from '../../hooks/useEvents';

export default function TCEAcademyPage() {
  const { events, loading } = useEvents('tceacademy');
  return (
    <CoursePage
      courses={events}
      loading={loading}
      pageTitle={'TCE-Academy'}
      category={'tceacademy'}
    />
  );
}
